module.exports = __webpack_public_path__ + "img/icon_map_2_5_hg_c.9fbf9f3e.png";